import {
  AdminDataWorkOpenAccessFundedDTO,
  AdminDataWorkOrcidSyncDTO,
  EmploymentPeriodDTO,
  EventDTO,
  EventPlaceDTO,
  ExternalIdDTO,
  OrganisationDTO,
  OrganisationToPersonDTO,
  PersonDTO,
  PersonEmailDTO,
  PersonNameDTO,
  PersonStatusDTO,
  PersonToOrganisationDTO,
  ProjectDTO,
  ProjectFundingReferenceDTO,
  ProjectFundingReferenceExternalIdentifierDTO,
  ProjectFundingReferenceFundingStreamDTO,
  ProjectFundingReferenceFundingSubstreamDTO,
  ProjectOtherPartnerDTO,
  ProjectPersonOtherDTO,
  ProjectToPersonDTO,
  ReferencedOrganisationDTO,
  ReferencedProjectDTO,
  SubjectDTO,
  UrlDTO,
  WorkDateTypeDTO,
  WorkDescriptionDTO,
  WorkDTO,
  WorkGeoLocationDTO,
  WorkGeoLocationPointDTO,
  WorkGeoLocationPolygonDTO,
  WorkHasPartDTO,
  WorkIsPartOfDTO,
  WorkIsPartOfOtherDTO as WorkIsPartOfOtherModel,
  WorkKeywordDTO,
  WorkLanguageDTO,
  WorkOrganisationDTO,
  WorkOrganisationOtherDTO,
  WorkOtherTitleDTO,
  WorkPersonDTO,
  WorkPersonOtherDTO,
  WorkPlaceDTO,
  WorkProjectDTO,
  WorkProjectOtherDTO,
  WorkPublisherDTO,
  WorkPublisherPlaceDTO,
  WorkRelatedIdentifierDTO,
  WorkRelatedIdentifierInternalDTO,
} from '../api/core';
import { InstitutionalId } from '../pages/edit/components/parts/InstitutionalIds';
import { OtherName } from '../pages/edit/components/parts/OtherNames';
import {
  PublistConfigProjectOrganisationDeterminationTypeEnum,
  PublistConfigProjectOrganisationFilterMembersEnum,
  PubListConfigReplacements,
} from '../api/core';
import { PubListConfigInternal } from '../pages/publig/types';
import { initialCslLocale } from './config';

export const getDefaultPersonName: () => PersonNameDTO = (): PersonNameDTO => {
  return {
    id: null,
    givenname: null,
    surname: null,
    isMain: false,
    salutation: null,
  };
};

export const getDefaultPerson: () => PersonDTO = (): PersonDTO => {
  return {
    id: null,
    note: null,
    personEmails: [],
    personNames: [{...getDefaultPersonName(), isMain: true}],
    personStatuses: [],
    urls: null,
    externalIds: [],
    personInstitutionalIds: [],
    personOrganisations: [],
    projects: null,
    adminDataPerson: {
      id: undefined,
      created: undefined,
      changed: undefined,
      deskman: null,
      origin: null,
      editorialStatus: null,
      hidden: null,
      dataLastSupplied: undefined,
      personChecked: undefined,
    },
  };
};

export const getDefaultProject: () => ProjectDTO = (): ProjectDTO => {
  return {
    id: null,
    name: null,
    otherNames: [],
    note: null,
    startDate: undefined,
    endDate: undefined,
    parents: null,
    childs: null,
    successor: null,
    predecessors: null,
    partner: null,
    projectPersons: [],
    projectPersonOthers: [],
    externalIds: null,
    projectInstitutionalIds: [],
    urls: null,
    projectOtherPartners: [],
    projectSubjects: [],
    projectFundingReferences: [],
    adminDataProject: {
      editorialStatus: null,
      hidden: null,
    },
  };
};

export const getDefaultOrganisation: () => OrganisationDTO = (): OrganisationDTO => {
  return {
    id: null,
    name: null,
    otherNames: [],
    note: null,
    startDate: undefined,
    endDate: undefined,
    projects: null,
    parents: null,
    childs: null,
    successor: null,
    predecessors: null,
    organisationPersons: [],
    organisationSubjects: [],
    adminDataOrganisation: {
      editorialStatus: null,
      hidden: null,
    },
    externalIds: null,
    organisationInstitutionalIds: [],
    urls: null,
  };
};

export const getDefaultWork: () => WorkDTO = (): WorkDTO => {
  return {
    id: null,
    applicationCountry: null,
    applicationNumber: null,
    edition: null,
    formSubject: null,
    format: null,
    grantNumber: null,
    issued: null,
    medium: null,
    note: null,
    number: null,
    numberOfPages: null,
    numberOfVolumes: null,
    patentFamily: null,
    patentId: null,
    patentType: null,
    peerReviewed: 'no_value',
    priorityCountry: null,
    priorityNumber: null,
    priorityPatentApplication: false,
    publicationNumber: null,
    publicationStatus: null,
    pubtype: null,
    resourceType: null,
    size: null,
    subseriesTitle: null,
    subtitle: null,
    title: null,
    titleSupplement: null,
    version: null,
    dataVersion: null,
    adminDataWork: {
      editorialStatus: null,
      hidden: null,
      obligatoryDelivery: false,
      projectsChecked: false,
      organisations: null,
      projects: null,
      adminDataWorkOpenAccess: {
        adminDataWorkOpenAccessFundeds: [],
      },
      adminDataWorkOrcidSyncs: [],
      license: null,
      licenseManagementStatus: null,
      licenseText: null,
    },
    events: null,
    externalIds: null,
    urls: null,
    workKeywords: null,
    workPublishers: null,
    workPersons: [],
    workOrganisations: [],
    workOrganisationOthers: [],
    workProjects: [],
    workProjectOthers: [],
    workDescriptions: [],
    workDateTypes: [],
    workIsPartOfs: [],
    workIsPartOfOthers: [],
    workLanguages: [
      {
        language: null,
      },
    ],
    workOtherTitles: [],
    workPersonOthers: [],
    workPlaces: [],
    externalRelatedIdentifiers: [],
    internalRelatedIdentifiersSource: [],
    internalRelatedIdentifiersTarget: [],
    workSubjects: [],
    workTitleAbbreviations: [],
    workHasParts: [],
    workGeoLocations: [],
  };
};

export const getDefaultLinkedPerson: () => WorkPersonDTO|ProjectToPersonDTO = () => {
  return {
    role: null,
    sequence: null,
    affiliation: null,
    externalIds: [],
    personName: null,
    topOrgas: null,
  };
};

export const getDefaultLinkedPersonOther: (externalIds: boolean) => WorkPersonOtherDTO | ProjectPersonOtherDTO = (externalIds: boolean): WorkPersonOtherDTO|ProjectPersonOtherDTO => {
  return externalIds
    ? {
        role: null,
        sequence: null,
        surname: null,
        givenname: null,
        externalIds: [],
      } as WorkPersonOtherDTO
    : {
        role: null,
        sequence: null,
        surname: null,
        givenname: null,
      } as ProjectPersonOtherDTO;
};

export const getDefaultExternalId: () => ExternalIdDTO = (): ExternalIdDTO => {
  return {
    type: null,
    externalId: null,
  };
};

export const getDefaultFundingStream: () => ProjectFundingReferenceFundingStreamDTO =
  (): ProjectFundingReferenceFundingStreamDTO => {
    return {
      fundingStream: null,
    };
  };

export const getDefaultFundingSubstream: () => ProjectFundingReferenceFundingSubstreamDTO =
  (): ProjectFundingReferenceFundingSubstreamDTO => {
    return {
      fundingSubstream: null,
    };
  };

export const getDefaultProjectFundingReferenceExternalIdentifier: () => ProjectFundingReferenceExternalIdentifierDTO =
  (): ProjectFundingReferenceExternalIdentifierDTO => {
    return {
      identifier: null,
    };
  };

export const getDefaultProjectFundingRef: () => ProjectFundingReferenceDTO = (): ProjectFundingReferenceDTO => {
  return {
    funderName: null,
    projectFundingReferenceFundingStreams: null,
    projectFundingReferenceFundingSubstreams: null,
    projectAcronym: null,
    externalProjectIdentifiers: null,
    projectTitle: null,
    projectUri: null,
  };
};

export const getDefaultInstitutionalId: () => InstitutionalId = (): InstitutionalId => {
  return {
    institution: null,
    value: null,
  };
};

export const getDefaultSubject: () => SubjectDTO = (): SubjectDTO => {
  return {
    subjectId: null,
    type: null,
  };
};

export const getDefaultProjectOtherPartner: () => ProjectOtherPartnerDTO = (): ProjectOtherPartnerDTO => {
  return {
    otherPartner: null,
  };
};

export const getDefaultPersonStatus: () => PersonStatusDTO = (): PersonStatusDTO => {
  return {
    affiliation: null,
    status: null,
  };
};

export const getDefaultUrl: () => UrlDTO = (): UrlDTO => {
  return {
    url: null,
    type: null,
  };
};

export const getDefaultOrganisationPerson: () => OrganisationToPersonDTO = () => {
  return {
    id: null,
    person: null,
    employmentPeriods: [],
  };
};

export const getDefaultProjectPerson: () => ProjectToPersonDTO = () => {
  return {
    id: null,
    person: null,
  };
};

export const getDefaultOtherName: () => OtherName = () => {
  return {
    id: null,
    otherName: null,
  };
};

export const getDefaultPersonEmail: () => PersonEmailDTO = () => {
  return {
    id: null,
    email: null,
    type: null,
  };
};

export const getDefaultEmploymentPeriod: () => EmploymentPeriodDTO = () => {
  return {
    startDate: undefined,
    endDate: undefined,
  };
};

export const getDefaultPersonOrganisation: () => PersonToOrganisationDTO = () => {
  return {
    organisation: null,
    employmentPeriods: [],
  };
};

export const getDefaultEventPlace: () => EventPlaceDTO = () => {
  return {
    eventPlace: null,
  };
};

export const getDefaultAdminDataWorkOpenAccessFunded: () => AdminDataWorkOpenAccessFundedDTO = () => {
  return {
    type: null,
    affiliation: null,
  };
};

export const getDefaultWorkGeoLocationPoint: () => WorkGeoLocationPointDTO = () => {
  return {
    latitude: null,
    longitude: null,
  };
};

export const getDefaultWorkGeoLocation: () => WorkGeoLocationDTO = (): WorkGeoLocationDTO => {
  return {
    place: null,
    pointLatitude: null,
    pointLongitude: null,
    boxWestBoundLongitude: null,
    boxEastBoundLongitude: null,
    boxSouthBoundLatitude: null,
    boxNorthBoundLatitude: null,
    workGeoLocationPolygon: getDefaultWorkGeoLocationPolygon(),
  };
};

export const getDefaultWorkGeoLocationPolygon: () => WorkGeoLocationPolygonDTO = (): WorkGeoLocationPolygonDTO => {
  return {
    inLongitude: null,
    inLatitude: null,
    workGeoLocationPoints: [
      getDefaultWorkGeoLocationPoint(),
      getDefaultWorkGeoLocationPoint(),
      getDefaultWorkGeoLocationPoint(),
      getDefaultWorkGeoLocationPoint(),
    ],
  };
};

export const getDefaultWorkPlace: () => WorkPlaceDTO = (): WorkPlaceDTO => {
  return {
    place: null,
  };
};

export const getDefaultWorkDateType: () => WorkDateTypeDTO = (): WorkDateTypeDTO => {
  return {
    date: undefined,
    type: null,
  };
};

export const getDefaultWorkDescription: () => WorkDescriptionDTO = (): WorkDescriptionDTO => {
  return {
    descriptionType: null,
    language: null,
    content: null,
  };
};

export const getDefaultWorkPublisher: () => WorkPublisherDTO = (): WorkPublisherDTO => {
  return {
    publisher: null,
    workPublisherPlace: [],
  };
};

export const getDefaultWorkPublisherPlace: () => WorkPublisherPlaceDTO = (): WorkPublisherPlaceDTO => {
  return {
    place: null,
  };
};

export const getDefaultWorkRelatedIdentifierInternal: () => WorkRelatedIdentifierInternalDTO = (): WorkRelatedIdentifierInternalDTO => {
  return {
    relationType: null,
    referencedWork: null,
  };
};

export const getDefaultWorkRelatedIdentifierExternal: () => WorkRelatedIdentifierDTO = (): WorkRelatedIdentifierDTO => {
  return {
    relationType: null,
    relatedIdentifier: null,
  };
};

export const getDefaultWorkOtherTitle: () => WorkOtherTitleDTO = (): WorkOtherTitleDTO => {
  return {
    language: null,
    otherTitle: null,
  };
};

export const getDefaultWorkProjectOther: () => WorkProjectOtherDTO = (): WorkProjectOtherDTO => {
  return {
    name: null,
    role: null,
  };
};

export const getDefaultWorkIsPartOfOtherModel: () => WorkIsPartOfOtherModel = (): WorkIsPartOfOtherModel => {
  return {
    name: null,
    pageLast: null,
    pageFirst: null,
    issue: null,
    volume: null,
    articleId: null,
    externalIds: [],
  };
};

export const getDefaultWorkPart: () => WorkIsPartOfDTO | WorkHasPartDTO = (): WorkIsPartOfDTO | WorkHasPartDTO => {
  return {
    referencedWork: null,
    pageLast: null,
    pageFirst: null,
    issue: null,
    volume: null,
    articleId: null,
  };
};

export const getDefaultWorkKeyword: () => WorkKeywordDTO = (): WorkKeywordDTO => {
  return {
    keyword: null,
  };
};

export const getDefaultWorkLanguage: () => WorkLanguageDTO = (): WorkLanguageDTO => {
  return {
    language: null,
  };
};

export const getDefaultAdminDataWorkOrcidSync: () => AdminDataWorkOrcidSyncDTO = (): AdminDataWorkOrcidSyncDTO => {
  return {
    orcidId: null,
    orcidVisibility: null,
    orcidPutCode: null,
  };
};

export const getDefaultWorkOrganisation: () => WorkOrganisationDTO = (): WorkOrganisationDTO => {
  return {
    organisation: null,
    role: null,
  };
};

export const getDefaultWorkOrganisationOther: () => WorkOrganisationOtherDTO = (): WorkOrganisationOtherDTO => {
  return {
    name: null,
    role: null,
  };
};

export const getDefaultWorkProject: () => WorkProjectDTO = (): WorkProjectDTO => {
  return {
    project: null,
    role: null,
  };
};

export const getDefaultEvent: () => EventDTO = (): EventDTO => {
  return {
    eventName: null,
    eventNumbering: null,
    eventPlaces: [],
    startDate: undefined,
    endDate: undefined,
  };
};

export const getDefaultPublist: () => PubListConfigInternal = (): PubListConfigInternal => {
  return {
    filterByType: [],
    filterByYear: [{start: null, end: null}],
    filterPersonByRole: [],
    filterPersons: [],
    groupByType: false,
    groupByYear: false,
    listType: null,
    locale: initialCslLocale,
    projectOrganisationConfig: {
      considerEmploymentPeriod: false,
      organisationIds: [],
      projectIds: [],
      excludeByRoles: [],
      restrictToRoles: [],
      determinationType: PublistConfigProjectOrganisationDeterminationTypeEnum.Members,
      filterMembers: PublistConfigProjectOrganisationFilterMembersEnum.All,
      withOrganisationHierarchy: false,
    },
    pubsort: 'stm',
    replacements: [],
    style: 'ieee-with-url',
    toc: false,
    useMainName: true,
    name: null,
    personIds: [],
    excludeByType: [],
    filterByPr: null,
    filterByCreationDate: [],
    filterByLang: [],
    filterByRoleExcl: [],
    filterIds: [],
    keyIds: [],
    linking: [],
    filterByRole: [],
  };
};

export const getDefaultPubListConfigReplacements: () => PubListConfigReplacements = (): PubListConfigReplacements => {
  return {
    key: null,
    value: null,
  };
};
